import React from "react";

import { WORD_BREAK_DELIMETER } from "utils/regex";

type TextProps = {
    children?: string;
};

export function Text({ children: text }: TextProps) {
    if (text === "[empty]" || !text) {
        return null;
    }

    const splitText = text.split(WORD_BREAK_DELIMETER);

    return (
        <>
            {splitText
                .flatMap((text: string, i: number) => {
                    if (text.match(WORD_BREAK_DELIMETER)) {
                        // if we match this must be the delimited character so place
                        // a word break after
                        return [
                            <React.Fragment key={i}>{text}</React.Fragment>,
                            <wbr key={`${i}-wbr`} />,
                        ];
                    }

                    return <React.Fragment key={i}>{text}</React.Fragment>;
                })
                .filter(Boolean)}
        </>
    );
}
